<template>
    <div v-show="examResult.status" :style="inline ? 'display: inline' : ''">
        <span style="position: relative; top: 5px;" :title="hideText ? text : ''">
            <kgr-icon
                :icon-class="iconClass"
                :small="!tinyIcons"
                :tiny="tinyIcons"
            />
        </span>
        <span v-if="!hideText">{{ text }}</span>
    </div>
</template>

<script>
import ClubExamResult from '../../js/dto/club/ClubExamResult.js';
import Icon from '../common/icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        examResult: {
            type: ClubExamResult,
            required: true,
        },
        tinyIcons: {
            type: Boolean,
            required: false,
            default: false,
        },
        hideText: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        iconClass() {
            if (this.examResult.isFailure()) {
                return 'close';
            }
            if (this.examResult.isPending()) {
                return 'clock';
            }
            if (this.examResult.isSuccess()) {
                return 'check';
            }
            return '';
        },
        text() {
            if (this.examResult.status) {
                return this.$t(`club.exam.result.status.${this.examResult.status}`);
            }
            return '';
        },
    },
};
</script>

<style scoped lang="scss">
</style>
